// Carte du rail accueil (E1a) — coque commune : carte blanche DS (jamais de
// carte coloree) + rangee d'en-tete « titre text-body semibold + slot droit »
// (lien drill-in brand OU sous-titre discret), conforme au mock fige.
import type { ReactNode } from 'react';

/** Lien de drill-in — navigation → BRAND (regle « brand = wayfinding », §4c). */
export const NAV_LINK =
  'touch-manipulation text-meta font-semibold text-brand-700 transition-colors ' +
  'hover:text-brand-600 dark:text-brand-400 dark:hover:text-brand-300';

export interface RailCardProps {
  title: string;
  /** Slot droit de l'en-tete : lien brand (drill-in) ou sous-titre slate. */
  trailing?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function RailCard({ title, trailing, children, className = '' }: RailCardProps) {
  return (
    <section
      className={`rounded-xl border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-700 dark:bg-slate-800 ${className}`.trim()}
    >
      <header className="mb-3 flex items-center justify-between gap-3">
        <h3 className="text-body font-semibold text-slate-800 dark:text-slate-100">{title}</h3>
        {trailing}
      </header>
      {children}
    </section>
  );
}
